import React, { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import Alert from './ui/Alert';
import { useCacheBusting } from 'hooks/useCacheBusting';
import { useLocalStorage } from 'hooks/useLocalStorage';
const ONE_SECOND = 1000;
const MAX_RETRIES = 3;
const CacheBusting = ({ className }) => {
    var _a;
    const { isAppOutdated } = useCacheBusting();
    const [countDown, setCountDown] = useState(10);
    const timer = useRef();
    const [reloadState, setReloadState] = useLocalStorage({ reloadCount: 0 });
    const reloadCount = (_a = reloadState === null || reloadState === void 0 ? void 0 : reloadState.reloadCount) !== null && _a !== void 0 ? _a : 0;
    const maxRetriesReached = reloadCount >= MAX_RETRIES;
    useEffect(() => {
        if (isAppOutdated === false) {
            setReloadState({ reloadCount: 0 });
        }
        if (maxRetriesReached) {
            return;
        }
        if (isAppOutdated) {
            if (countDown > 0) {
                timer.current = setTimeout(() => {
                    setCountDown((currentCountDown) => currentCountDown - 1);
                }, ONE_SECOND);
            }
            else {
                clearTimeout(timer.current);
                setReloadState({ reloadCount: reloadCount + 1 });
                window.location.reload();
            }
        }
        else {
            clearTimeout(timer.current);
        }
    }, [isAppOutdated, countDown, maxRetriesReached]);
    if (!isAppOutdated) {
        return null;
    }
    return (React.createElement(Alert, { type: "error", className: classnames('z-50 w-full', className) },
        !maxRetriesReached && (React.createElement("span", null,
            "The page you are viewing is outdated and will refresh in ",
            countDown,
            ' ',
            "second(s).")),
        maxRetriesReached && (React.createElement("span", null, "There was a problem reloading the app; please contact the support team."))));
};
export default CacheBusting;
